
import { Component, Ref, Vue } from 'vue-property-decorator'
import { Action } from 'vuex-class';

import User from '@/store/modules/user';

import GoogleAutocomplete from './GoogleAutocomplete.vue';

@Component({
  components: {
  }
})
export default class SetLocation extends Vue {
  @Action fetchRestaurantsNearby: (coords: Coords) => void;
  @Ref('address') readonly addressRef: GoogleAutocomplete;

  locatingUser = false;

  mounted() {
    this.addressRef.geolocateUser();
  }

  locateUser() {
    this.locatingUser = true;
    this.addressRef.geolocateUser();
  }

  googlePlacesErrorHandler(err) {
    this.$log.error(err);
    this.$toasted.error(err);
  }

  async updateCoordinates({ latitude, longitude }) {
    if (!User.customerLocation.hasCoords) {
      await this.fetchRestaurantsNearby({ latitude, longitude });
      User.setLocation({ latitude, longitude } as CustomerLocation);
    }
  }

  async getAddressData(location, place, id): Promise<void> {
    const { formatted_address, adr_address, name, url, place_id } = place;
    const { latitude, longitude, postal_code, street_number, locality, route } = location;
    this.$log.info('getAddressData', { location, place, id });
    // eslint-disable-next-line
    User.setLocation({
      latitude,
      locality,
      longitude,
      // eslint-disable-next-line
      postal_code,
      route,
      // eslint-disable-next-line
      street_number,
      placeInfo: {
        // eslint-disable-next-line
        adr_address,
        // eslint-disable-next-line
        formatted_address,
        name,
        // eslint-disable-next-line
        place_id,
        url,
      }
    });
    await this.fetchRestaurantsNearby({ latitude, longitude });
  }

  get types() {
    return '(regions)';
  }

  get geoTypes() {
    return '(regions)';
  }

  get placeholderText() {
    return 'Search a city or zip code'
  }
}
